import { atom } from "recoil";

export const dataSearchList = atom({
  key: "dataSearchListIntransit",
  default: {},
});
